import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import DashboardCard from './DashboardCard';
import { budgetBand, formatTry } from '../constants';
import { Footnote, MoreLink } from '../styles';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Center = styled.div`
  margin-top: -52px;
  text-align: center;
`;

const Pct = styled.div`
  font-size: 26px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const Sub = styled.div`
  font-size: 11px;
  color: #6B7280;
`;

const StatLine = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 12px;
  color: #52514e;
  padding: 4px 0;

  strong { color: ${({ theme }) => theme.colors.text.primary}; }
`;

export default function BudgetUsageCard({ slice }) {
  const { t } = useTranslation();
  const history = useHistory();
  const b = slice.data;

  const pct = Math.min(150, b?.usagePct ?? 0);
  const angle = Math.min(180, (pct / 100) * 180);
  const rad = (deg) => ((deg - 180) * Math.PI) / 180;
  const arc = (deg) => `${90 + 70 * Math.cos(rad(deg))},${86 + 70 * Math.sin(rad(deg))}`;

  return (
    <DashboardCard
      cardKey="butce-kullanimi"
      title={t('expenseDashboard.budget.title')}
      meta={t('expenseDashboard.budget.meta')}
      span={4}
      spanMd={3}
      loading={slice.loading}
      empty={!b}
    >
      {b && (b.hasBudget ? (
        <Wrap>
          <svg width="180" height="96" viewBox="0 0 180 96" aria-hidden="true">
            <path d={`M ${arc(0)} A 70 70 0 0 1 ${arc(180)}`} fill="none" stroke="#EEF1F5" strokeWidth="12" strokeLinecap="round" />
            {b.usagePct > 0 && (
              <path d={`M ${arc(0)} A 70 70 0 0 1 ${arc(angle)}`} fill="none" stroke={budgetBand(b.usagePct)} strokeWidth="12" strokeLinecap="round" />
            )}
          </svg>
          <Center>
            <Pct>%{b.usagePct}</Pct>
            <Sub>{t('expenseDashboard.budget.remaining', { amount: formatTry(b.remaining) })}</Sub>
          </Center>
          <div style={{ width: '100%', marginTop: 12 }}>
            <StatLine>
              <span>{t('expenseDashboard.budget.monthly')}</span>
              <strong>{formatTry(b.monthlyAmount)}</strong>
            </StatLine>
            <StatLine>
              <span>{t('expenseDashboard.budget.spent')}</span>
              <strong>{formatTry(b.spentTotal)}</strong>
            </StatLine>
            <StatLine>
              <span>{t('expenseDashboard.budget.pending')}</span>
              <strong>{formatTry(b.pendingTotal)}</strong>
            </StatLine>
          </div>
          {b.nonTryCount > 0 && <Footnote>{t('expenseDashboard.fxExcluded', { count: b.nonTryCount })}</Footnote>}
        </Wrap>
      ) : (
        <Wrap style={{ justifyContent: 'center', flex: 1 }}>
          <Sub style={{ padding: '24px 0 8px', textAlign: 'center' }}>{t('expenseDashboard.budget.none')}</Sub>
          <MoreLink type="button" onClick={() => history.push('/expense-budgets')}>
            {t('expenseDashboard.budget.defineLink')}
          </MoreLink>
        </Wrap>
      ))}
    </DashboardCard>
  );
}
